"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationSessionDto = instanceOfOrientationSessionDto;
exports.OrientationSessionDtoFromJSON = OrientationSessionDtoFromJSON;
exports.OrientationSessionDtoFromJSONTyped = OrientationSessionDtoFromJSONTyped;
exports.OrientationSessionDtoToJSON = OrientationSessionDtoToJSON;
exports.OrientationSessionDtoToJSONTyped = OrientationSessionDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationSessionDto interface.
 */
function instanceOfOrientationSessionDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    return true;
}
function OrientationSessionDtoFromJSON(json) {
    return OrientationSessionDtoFromJSONTyped(json, false);
}
function OrientationSessionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
    };
}
function OrientationSessionDtoToJSON(json) {
    return OrientationSessionDtoToJSONTyped(json, false);
}
function OrientationSessionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
    };
}
//# sourceMappingURL=OrientationSessionDto.js.map